import type { BBox } from '../api/map.ts'

/**
 * True when the bounding box has zero (or inverted) area. Leaflet reports
 * such bounds transiently while the map container is still laying out
 * (a zero-size container yields identical corners); fetching meters for a
 * zero-area box is wasted load that can flash a misleading empty layer (D3).
 */
export function isDegenerateBBox(bbox: BBox): boolean {
  return bbox.maxLon <= bbox.minLon || bbox.maxLat <= bbox.minLat
}
